export const ADD_CREDIT_CARD = 'ADD_CREDIT_CARD'
export const ADD_CREDIT_CARD_FAILED = 'ADD_CREDIT_CARD_FAILED'
export const RESET_ERROR_STATE = 'RESET_ERROR_STATE'
export const ADD_PAYMENT_METHOD_SUCCESS = 'ADD_PAYMENT_METHOD_SUCCESS'
export const ADD_CREDIT_CARD_RESET = 'ADD_CREDIT_CARD_RESET'

export const PAGSEGURO_MERCHANT_QUERY_PARAM = 'merchant'

export const PAGSEGURO_MERCHANT_KEYS = {
    'ACCO_8BB1BBBD-AC99-4F64-BF06-486357412464': window.PAGSEGURO_KEY,
    'ACCO_2FE191EB-1B6E-495D-8205-FCD34B300D36': window.PAGSEGURO_KEY_2,
}
